module.exports = __webpack_public_path__ + "img/circle.80a62737.png";